// Patty APIs

import "whatwg-fetch";
import { optionsGen } from "../helpers/api";
import { PATTY_API_URL } from "../config";

export function getDocumentBasedResponse(payload) {
  return fetch(`${PATTY_API_URL}/openai/question`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getKnowledgeEnhancedResponse(payload) {
  return fetch(`${PATTY_API_URL}/openai/knowledge-enhanced-answer`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getInvalidityChartFromPatent(payload, onMessageReceived, onClose = () => {}) {
  const socket = new WebSocket(`${PATTY_API_URL.replace('http', 'ws')}/invalidity-chart/stream/from-patent`);
  socket.addEventListener("open", () => {
    socket.send(JSON.stringify(payload));
  });
  socket.addEventListener("message", (event) => {
    onMessageReceived(JSON.parse(event.data));
  });
  socket.addEventListener("close", () => {
    if (onClose) {
      onClose();
    }
  });
  return socket;
}

export function getInvalidityChartFromText(payload, onMessageReceived, onClose = () => {}) {
  const socket = new WebSocket(`${PATTY_API_URL.replace('http', 'ws')}/invalidity-chart/stream/from-text`);
  socket.addEventListener("open", () => {
    socket.send(JSON.stringify(payload));
  });
  socket.addEventListener("message", (event) => {
    onMessageReceived(JSON.parse(event.data));
  });
  socket.addEventListener("close", () => {
    if (onClose) {
      onClose();
    }
  });
  return socket;
}
export function getShortSummary(payload, onMessageReceived, onClose = () => {}) {
  const baseWsUrl = PATTY_API_URL.replace('http', 'ws');
  const endpoint = `${baseWsUrl}/invalidity-chart/stream/short-summarize`
  const socket = new WebSocket(endpoint);
  socket.addEventListener("open", () => {
    socket.send(JSON.stringify(payload));
  });
  socket.addEventListener("message", (event) => {
    onMessageReceived(JSON.parse(event.data));
  });
  socket.addEventListener("close", () => {
    if (onClose) {
      onClose();
    }
  });
  return socket;
}

export function getSummaryPatent(payload, onMessageReceived, onClose = () => {}, isTargetPatent = false) {
  const baseWsUrl = PATTY_API_URL.replace('http', 'ws');
  const endpoint = isTargetPatent ? 
    `${baseWsUrl}/invalidity-chart/stream/summarize/patent` : 
    `${baseWsUrl}/invalidity-chart/stream/short-summarize/patent`;
  const socket = new WebSocket(endpoint);
  socket.addEventListener("open", () => {
    socket.send(JSON.stringify(payload));
  });
  socket.addEventListener("message", (event) => {
    onMessageReceived(JSON.parse(event.data));
  });
  socket.addEventListener("close", () => {
    if (onClose) {
      onClose();
    }
  });
  return socket;
}

export async function getEmbeddings(payload, retries = 3) {
  const fetchEmbeddings = async (attempt) => {
    try {
      const resp = await fetch(`${PATTY_API_URL}/invalidity-chart/embeddings`, optionsGen("POST", payload, true));
      if (!resp.ok) {
        const err = await resp.json();
        throw err;
      }
      return await resp.json();
    } catch (error) {
      if (attempt < retries) {
        return fetchEmbeddings(attempt + 1);
      } else {
        throw error;
      }
    }
  };

  return fetchEmbeddings(0);
}

export async function getInvalidityElementByPatent(payload, retries = 3) {
  const fetchInvalidityElements = async (attempt) => {
    try {
      const resp = await fetch(
        `${PATTY_API_URL}/invalidity-chart/from-patent/list-advanced`,
        optionsGen("POST", payload, true)
      );
      if (!resp.ok) {
        const err = await resp.json();
        throw err;
      }
      const data = await resp.json();
      const processedData = {
        quotedStrings: data.quotedStrings.map((item) => ({
          text: item.text,
          embeddings: item.embeddings,
          similarity: item.similarity,
        })),
        claimEmbedding: data.claimEmbedding,
      };

      return processedData;
    } catch (error) {
      if (attempt < retries) {
        return fetchInvalidityElements(attempt + 1);
      } else {
        throw error;
      }
    }
  };

  return fetchInvalidityElements(0);
}

// Function to record user actions (like/dislike) in claim charting tool
export function recordUserAction(payload) {
  return fetch(`${PATTY_API_URL}/pearl/user-actions/`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function recordPearlUsage(payload) {
  return fetch(`${PATTY_API_URL}/pearl/generate-usage/`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getPearlUsage(payload) {
  const queryParams = new URLSearchParams(payload);

  return fetch(`${PATTY_API_URL}/pearl/get-usage/?${queryParams.toString()}`, optionsGen("GET", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function createChart(payload) {
  return fetch(`${PATTY_API_URL}/pearl/charts/`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function updateChart(payload) {
  return fetch(`${PATTY_API_URL}/pearl/charts/update`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getChartData(chartId) {
  return fetch(`${PATTY_API_URL}/pearl/charts/${chartId}`, optionsGen("GET", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getChartsByUser(userId) {
  return fetch(`${PATTY_API_URL}/pearl/charts/by-user/${userId}`, optionsGen("GET", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function deleteChartById(chartId) {
  return fetch(`${PATTY_API_URL}/pearl/charts/${chartId}`, optionsGen("DELETE", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function savePriorArtFileRecord(payload) {
  return fetch(`${PATTY_API_URL}/pearl/prior-art-file/`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}


export function getPriorArtFileRecordByUser(userId) {
  return fetch(`${PATTY_API_URL}/pearl/prior-art-file/by-user/${userId}`, optionsGen("GET", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function deletePriorArtFileRecord(fileId) {
  return fetch(`${PATTY_API_URL}/pearl/prior-art-file/${fileId}`, optionsGen("DELETE", null, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getInfringementElementByStandard(standardName, payload) { // deprecated, should be removed after migration
  return fetch(`${PATTY_API_URL}/infringement/${standardName}/list`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}

export function getInfringementElementByStandardAdvanced(standardName, payload) {
  return fetch(`${PATTY_API_URL}/infringement/${standardName}/list-advanced`, optionsGen("POST", payload, true))
    .then(resp => {
      if (!resp.ok) {
        return resp.json().then(err => { throw err; });
      }
      return resp.json();
    });
}
